<template>
    <div class="support-tickets">
        <section>
            <div class="head">
                <h3 v-if="showTickets">{{$t('user.support.yourtickets')}}</h3>
                <b-row v-else>
                  <b-col>
                    <pre v-if="isLoading">
                    The Monkey is loading your tickets.
                  </pre>
                    <pre v-else>
                    {{$t('user.support.notickets')}}
                  </pre>
                  </b-col>
                </b-row>
            </div>
            <div class="info">
                <table v-if="showTickets" class="table table--overview">
                    <thead>
                    <tr>
                        <th>
                            {{$t('user.support.tickettitle')}}
                        </th>
                        <th>
                            {{$t('user.support.created')}}
                        </th>
                        <th>
                            {{$t('user.support.state')}}
                        </th>
                        <th>
                            {{$t('user.support.tag')}}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                        <support-ticket-item
                                v-for="item in filteredTickets"
                                :key="item.id"
                                v-bind="item"
                        >
                        </support-ticket-item>
                    </tbody>
                </table>
            </div>
          <b-form-group>
            <b-form-checkbox
              v-model="showOpen"
            >
              {{$t('user.support.showopen')}}
            </b-form-checkbox>
          </b-form-group>
        </section>
    </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import SupportTicketItem from './SupportTicketItem'

export default {

  name: 'SupportTicketSection',

  components: {
    SupportTicketItem
  },

  data () {
    return {
      showOpen: true
    }
  },

  computed: {
    ...mapState('support', [
      'tickets'
    ]),
    ...mapGetters('common', [
      'isLoading'
    ]),
    showTickets () {
      return this.tickets.length > 0
    },

    filteredTickets () {
      if (!this.showOpen) {
        return this.tickets
      }

      return this.tickets.filter(elm => elm.state !== 'closed')
    }
  }
}
</script>
